import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const HomePage = lazy(
  () => import('./HomePage.eager').then(mod => ({default: mod.HomePage})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
